<div class="main-container">
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    class="header-container grad-purple"
  >
    <button
      mat-icon-button
      (click)="close()"
      aria-label="Close send email panel"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <h3>
      <span class="title">{{ title }}</span>
    </h3>
  </div>
  <div class="content-container">
    <app-compose-email
      [emailType]="emailType"
      [recipientPersonId]="recipientPersonId"
      [emailCustomizationInput]="emailCustomization"
      (composedEmailForm)="onComposeEmailComplete($event)"
    >
    </app-compose-email>
    <span>
      @if (isRecipientInvalid) {
        <mat-icon>warning</mat-icon>
      }
      {{ footer }}
    </span>
    @if (credentialCoverageWarning) {
      <span class="credential-coverage-warning">
        <mat-icon>info</mat-icon>
        {{ credentialCoverageWarning }}
      </span>
    }
    <div class="email-buttons" fxLayout fxLayoutGap="10px">
      <button
        mat-flat-button
        color="primary"
        [disabled]="!isValid()"
        (click)="send()"
      >
        {{ sendButtonText }}
      </button>
      <button mat-stroked-button class="mat-secondary-button" (click)="close()">
        {{ cancelButtonText }}
      </button>
    </div>
  </div>
</div>
